import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase';
import { CALLABLE_CRAWLER_FAILURE_APPLY_DISPOSITION } from '../utils/crawlerFailureDispositionConstants';

export async function applyCrawlerFailureDisposition({
  failureId,
  disposition,
  website,
}) {
  const callable = httpsCallable(
    functions,
    CALLABLE_CRAWLER_FAILURE_APPLY_DISPOSITION,
  );
  const payload = { failureId, disposition };
  if (typeof website === 'string' && website.trim()) {
    payload.website = website.trim();
  }
  const result = await callable(payload);
  return result.data;
}
